
import React, { useState, useEffect } from 'react'
import { CommonHeader, Loader, ErrorSuccessModal, DropDown } from '../../../components/commons';
import { connect } from 'react-redux';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
// import { Label, Input } from 'reactstrap';
import {
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Label,
    FormGroup,
    Input,
    Row,
    Col,
    Button
} from 'reactstrap';
import { DownloadIcon, DeleteIcon, CalenderIcon } from "../../../components/Icon";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { RootState } from '../../../redux/rootReducers';
import { resetOpenItemsError, resetOpenItemsSuccess } from '../../../redux/openItems';
import {
    getAllJobsTrackerListAction,
    resetJobTrackerListing
} from '../../../redux/listing';
import {
    addAdminOpenItemsAction,
    getAdminOpenItemsSingleAction,
    updateAdminOpenItemsAction
} from '../../../redux/openItems';
import { resetSession } from '../../../redux/auth';
import { ClientType } from '../../../redux/auth/authTypes';
import { JobTrackerListingType } from '../../../redux/listing/listingTypes';
import { ItemTypes, AddOpenItemPayload } from '../../../commonTypes/openItemsTypes';
import { GetJobTrackerListingPayload } from '../../../commonTypes/listing';
import { returnInputFieldLength } from '../../../utils/commonFunctions';
import { FORMATS } from '../../../constant/openItemConst';
import { capitalize } from '../../../utils/commonFunctions';
import toast, { Toaster } from 'react-hot-toast';


const ITEM_DATA_EDIT: ItemTypes[] = [{
    item_name: '',
    format: {},
    due_date: null
}];


type dropDownItemType = {
    value: number | undefined;
    label: string | undefined;
};

type AppProps = {
    fetching: boolean;
    success: number | null;
    token: string | null;
    error: string | null;
    statusCode: number | null;
    dispatchResetOpenItemsError: () => void;
    dispatchResetOpenItemsSuccess: () => void;
    clientList: ClientType[] | [];
    jobTrackerListing: [] | JobTrackerListingType[];
    dispatchGetClientsActiveJobAction: (data: GetJobTrackerListingPayload) => void;
    dispatchResetJobTrackerListing: () => void;
    dispatchAddAdminOpenItemsAction: (data: any) => void;
    dispatchResetSession: () => void;
    dispatchGetAdminOpenItemsSingle: (data: any) => void;
    dispatchUpdateAdminOpenItemsAction: (data: any) => void;
    history: any;
    adminOpenItemSingle: any;
}

const AdminOpenItemEdit = ({
    fetching,
    clientList,
    success,
    statusCode,
    token,
    error,
    jobTrackerListing,
    dispatchResetOpenItemsError,
    dispatchResetOpenItemsSuccess,
    dispatchGetClientsActiveJobAction,
    dispatchResetJobTrackerListing,
    dispatchAddAdminOpenItemsAction,
    dispatchResetSession,
    history,
    adminOpenItemSingle,
    dispatchGetAdminOpenItemsSingle,
    dispatchUpdateAdminOpenItemsAction
}: AppProps) => {

    const search = useLocation();
    const urlArr = search.pathname.split('/')
    const jobId = urlArr[urlArr.length - 1];
    const { currentTab } = history?.location?.state;


    const [clientId, setClientId] = useState<any>(null);
    const [itemData, setItemData] = useState(JSON.parse(JSON.stringify(ITEM_DATA_EDIT)));
    const [finalClientList, setFinalClientList] = useState<dropDownItemType[] | []>([]);
    const [finalJobList, setFinalJobList] = useState<dropDownItemType[] | []>([]);
    const [summary, setSummary] = useState<string>('')
    const [selectedJobDetails, setSelectedJobDetails] = useState<any>([])
    const [clientSelected, setClientSelected] = useState<any>({
        value: null,
        label: 'Select Client'
    });

    const [jobSelected, setJobSelected] = useState<any>({
        value: null,
        label: 'Select Job Type'
    });

    useEffect(() => {
        dispatchResetOpenItemsError();
        dispatchResetOpenItemsSuccess();
        dispatchResetJobTrackerListing();
        let data = {
            jobId,
            token
        }
        dispatchGetAdminOpenItemsSingle(data);
    }, []);

    useEffect(() => {
        if (adminOpenItemSingle && adminOpenItemSingle.summary) {
            setSummary(adminOpenItemSingle.summary)
        }

        if (adminOpenItemSingle && adminOpenItemSingle.documents && adminOpenItemSingle.documents.length) {
            let arr: any[] = []
            adminOpenItemSingle.documents.map((item: any) => {

                arr.push({
                    due_date: item.due_date,
                    format: {
                        value: item.format,
                        label: capitalize(item.format)
                    },
                    item_name: item.item_name,
                    item_id: item.item_id ? item.item_id : null

                })
            })
            setItemData(arr)
        }

    }, [adminOpenItemSingle])

    useEffect(() => {
        if (clientList.length > 0) {
            let finalClientData = clientList?.map((client: ClientType) => {
                return {
                    value: client.client_code,
                    label: `(${ client.client_code })  ${ client.company_name }`
                }
            })

            setFinalClientList(finalClientData)
        }

    }, [clientList]);

    useEffect(() => {
        if (jobTrackerListing.length > 0) {
            let finalJobsData = jobTrackerListing?.map((job: any) => {
                return {
                    value: job.id,
                    label: `${ job.job_type }_${ moment(job.period_ended).format('DD-MM-YYYY') }(${ job.id })`
                }
            })

            setFinalJobList(finalJobsData)
        }

    }, [jobTrackerListing]);

    const handleChange = (dataKey: any, value: any, index: number) => {

        if (value === 'Invalid date') return false;

        let temp = itemData
        temp[index][dataKey] = value
        setItemData([...temp])
    }

    const returnFileFormat = (format: string) => {
        switch (format) {
            case 'image':
                return 'Image';
            case 'word':
                return 'Word';
            case 'pdf':
                return 'PDF';
            case 'excel':
                return 'Excel';
            case 'hard_copy':
                return 'Hard Copy';
            default:
                return 'Image';
        }
    }

    const renderItems = () => {
        let arr: any[] = []

        itemData && itemData.map((item: any, i: number) => {
            if (item.hasOwnProperty('item_name')) {
                arr.push(
                    <div className="col-6 mt-2 mb-2">
                        <Input
                            type='text'
                            placeholder="item name"
                            value={item['item_name'] || ''}
                            onChange={(e) => handleChange('item_name', e.target.value, i)}
                            maxLength={100}
                        />
                        <p className="text-right mt-1 text-muted m-0 p-0" style={{ fontSize: '11px' }}>
                            {returnInputFieldLength(item['item_name'].length, 100)}
                        </p>
                    </div>
                )
            }

            if (item.hasOwnProperty('format')) {
                arr.push(
                    <div className="col-3 mt-2 mb-2">

                        {item['format'].hasOwnProperty('label') && <div className="d-none">{item['format'].label = returnFileFormat(item['format'].value)}</div>}
                        <DropDown
                            placeholder="Formats"
                            options={FORMATS}
                            handleChange={(option) => handleChange('format', option, i)}
                            value={item['format']}
                        />
                    </div>
                )
            }

            if (item.hasOwnProperty('due_date')) {
                arr.push(<div className="col-3 mt-2 mb-2">

                    <Row>
                        <Col md="11" className="date-picker-wraper mr-0">
                            <Label className="m-0 p-0">
                                <DatePicker
                                    dateFormat="yyyy-MM-dd"
                                    // selected={item['due_date'] || null}
                                    selected={item['due_date'] ? new Date(moment(`${ item['due_date'] }T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(value: any) => handleChange('due_date', moment(value).format('YYYY-MM-DD'), i)}
                                    selectsStart
                                    showMonthDropdown
                                    showYearDropdown
                                    startDate={null}
                                    endDate={null}
                                    className="form-control"
                                />
                                <span className="calender-icon">
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </Col>
                        <Col xs={1} className="m-0 p-0">
                            {itemData.length > 1 ? <span onClick={() => handleRemoveRow(i)}><DeleteIcon /></span> : null}
                        </Col>
                    </Row>
                </div>
                )
            }
        })
        return arr;
    }

    const handleCancel = () => {
        setItemData(JSON.parse(JSON.stringify(ITEM_DATA_EDIT)))
        history.goBack();
    }

    const handleRemoveRow = (index: any) => {
        let temp = JSON.parse(JSON.stringify(itemData))
        temp.splice(index, 1)
        setItemData(temp);
    }
    const handleAddRow = () => {
        let temp: any = JSON.parse(JSON.stringify(itemData))
        temp.push(...JSON.parse(JSON.stringify(ITEM_DATA_EDIT)))
        setItemData(temp)
    };

    const validateSubmit = () => {

        if (!summary) return false;

        for (const item in itemData) {
            if (itemData[item].due_date === null
                || (itemData[item].format
                    && Object.keys(itemData[item].format).length === 0
                    && Object.getPrototypeOf(itemData[item].format) === Object.prototype)
                || itemData[item].item_name === '') {
                return false
            }
        }

        return true
    }

    const handleSubmit = () => {
        let validation = validateSubmit()
        if (!validation) {
            toast.error('Please provide all the mandetory fields!', {
                duration: 3000
            });

            return false
        }

        let tempData = JSON.parse(JSON.stringify(itemData))
        tempData.map((data: any) => {
            data.format = data.format.value;
            data.due_date = moment(data?.due_date).format('YYYY-MM-DD')
        })

        const params: AddOpenItemPayload = {
            job_id: Number(jobId),
            summary,
            item_data: tempData,
            token
        }
        dispatchUpdateAdminOpenItemsAction(params)
    }

    const redirectToListing = () => {
        history.push({
            pathname: `/open-items-admin`,
            state: { currentTab }
        });
    }


    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired"
                        buttonText="Logout"
                        onPress={() => {
                            dispatchResetSession();
                            dispatchResetOpenItemsError();
                        }}
                        statusCode={statusCode}
                    />
                )
            } else if (error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => dispatchResetOpenItemsError()}
                    />
                )
            }
        }

        if (success === 1) {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message="Open Item Updated Successfully!"
                    buttonText="OK"
                    onPress={() => {
                        dispatchResetOpenItemsSuccess();
                        redirectToListing();
                    }}
                    statusCode={statusCode}
                />
            )
        }

        return false;
    }

    return (
        <div className="row">
            <div className="col-md-6 mb-3">
                <CommonHeader title="Edit Open Items" />
            </div>

            <div className="col-md-12 mt-4">
                <div className="content-area">
                    <div className='row'>
                        <div className="col-6">
                            <Label>Client</Label>
                            <div>{adminOpenItemSingle?.client_name} ({adminOpenItemSingle?.client_code})</div>
                        </div>
                        <div className="col-6">
                            <Label>Job Type</Label>
                            <div>{adminOpenItemSingle?.job_type}({adminOpenItemSingle?.job_id})</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className='col-12'>
                            <Label>
                                Summary*
                            </Label>
                            <Input
                                type="textarea"
                                name="text"
                                id="exampleText"
                                value={summary}
                                onChange={(e) => setSummary(e.target.value)}
                                placeholder="Write your summary here..."
                                maxLength={250}
                            />
                            <p className="text-right mt-1" style={{ fontSize: '11px', }}> {returnInputFieldLength(summary.length, 250)}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6">
                            <Label>Item name*</Label>
                        </div>
                        <div className="col-3">
                            <Label>Format*</Label>
                        </div>
                        <div className="col-3">
                            <Label>
                                Due Date*
                            </Label>
                        </div>
                    </div>
                    <div className="row">
                        {renderItems()}
                    </div>


                    <div className="row mt-3">
                        <div className="col-12">
                            <button className="btn btn-sm btn-outline-secondary" onClick={handleAddRow}>Add More</button>
                        </div>
                    </div>

                    <Row>
                        <Col xs={12} className="text-right">
                            <button className="btn btn-link" onClick={handleCancel}>Cancel</button>
                            <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                        </Col>
                    </Row>

                </div>
            </div>
            {fetching && <Loader />}
            {handleErrorModal()}
            <Toaster />
        </div>
    )
};

const mapStateToProps = (state: RootState) => ({
    clientList: state.auth.assignedClientsToUserList,
    token: state.auth.token,
    fetching: state.openItems.fetching,
    success: state.openItems.success,
    statusCode: state.openItems.statusCode,
    error: state.openItems.error,
    jobTrackerListing: state.listing.jobTrackerListing,
    adminOpenItemSingle: state.openItems.adminOpenItemSingle
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
    dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
    dispatchGetClientsActiveJobAction: (data: GetJobTrackerListingPayload) =>
        dispatch(getAllJobsTrackerListAction(data)),
    dispatchResetJobTrackerListing: () => dispatch(resetJobTrackerListing()),
    dispatchUpdateAdminOpenItemsAction: (data: any) => dispatch(updateAdminOpenItemsAction(data)),
    dispatchGetAdminOpenItemsSingle: (data: any) => dispatch(getAdminOpenItemsSingleAction(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(AdminOpenItemEdit);